const csosn = [
  {
    csosn: '101',
    cfop: [
      '5102',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description: 'Tributada pelo Simples Nacional com permissão de crédito;',
  },
  {
    csosn: '102',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description: 'Tributada pelo Simples Nacional sem permissão de crédito;',
  },
  {
    csosn: '202',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5401',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description:
      'Tributada sem permissão de crédito e com cobrança do ICMS por substituição tributária;',
  },
  {
    csosn: '500',
    cfop: [
      '5405',
      '5949',
      '5152',
      '5401',
      '5929',
      '6108',
      '5403',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description:
      'CMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação;',
  },
  // {
  //   csosn: '103',
  //   cfop: ['5101', '5102', '5103', '5104', '5115'],
  //   description:
  //     'Isenção do ICMS no Simples Nacional para faixa de receita bruta;',
  // },
  {
    csosn: '300',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description: 'Imune;',
  },
  {
    csosn: '400',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5933',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description: 'Não tributada pelo Simples Nacional;',
  },
  {
    csosn: '900',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description: 'Outros (a critério da UF);',
  },
  // {
  //   csosn: '00',
  //   cfop: ['5101', '5102', '5103', '5104', '5115', '5949', '5152', '5929'],
  //   description: 'Tributada Integralmente;',
  // },
  {
    csosn: '103',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description:
      'Isenção do ICMS no Simples Nacional para faixa de receita bruta;',
  },
  {
    csosn: '201',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5401',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description:
      'Tributada com permissão de crédito e com cobrança do ICMS por substituição tributária;',
  },
  {
    csosn: '203',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5115',
      '5949',
      '5152',
      '5401',
      '5929',
      '6108',
      '5403',
      '5405',
      '5124',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
    description:
      'Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por substituição tributária;',
  },
  // {
  //   csosn: '40',
  //   cfop: [],
  //   description: 'Isenta;',
  // },
  // {
  //   csosn: '41',
  //   cfop: [],
  //   description: 'Não Tributada;',
  // },
  // {
  //   csosn: '60',
  //   cfop: [],
  //   description: 'ICMS cobrado anteriormente por substituição tributária;',
  // },
];

const cst = [
  {
    cst: '00',
    label: '00 - Tributada integralmente',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5105',
      '5115',
      '5949',
      '5152',
      '5124',
      '5922',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
  },
  // { cst: '10', label: '10 - Tributada e com cobrança do ICMS por substituição tributária', cfop: ['5101', '5102', '5103', '5104', '5105', '5115', '5949', '5152'] },
  {
    cst: '20',
    label: '20 - Com redução de base de cálculo',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5105',
      '5115',
      '5949',
      '5152',
      '5124',
      '5922',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
  },
  {
    cst: '30',
    label:
      '30 - Isenta ou não tributada e com cobrança do ICMS por substituição tributária',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5105',
      '5115',
      '5949',
      '5152',
      '5124',
      '5922',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
  },
  {
    cst: '40',
    label: '40 - Isenta',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5949',
      '5152',
      '5124',
      '5922',
      '5405',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
  },
  {
    cst: '41',
    label: '41 - Não tributada',
    cfop: ['5103', '5949', '5152', '5124', '5922', '5151', '5114', '5409', '5910'],
  },
  {
    cst: '50',
    label: '50 - Suspensão',
    cfop: ['5103', '5949', '5124', '5922', '5151', '5114', '5409', '5910'],
  },
  {
    cst: '51',
    label: '51 - Diferimento',
    cfop: ['5101', '5102', '5949', '5124', '5922', '5151', '5114', '5409', '5910'],
  },
  {
    cst: '60',
    label: '60 - ICMS cobrado anteriormente por substituição tributária',
    cfop: ['5405', '5922', '5114', '5409', '5910'],
  },
  {
    cst: '70',
    label:
      '70 - Com redução de base de cálculo e cobrança do ICMS por substituição tributária',
    cfop: ['5405', '5922', '5114', '5409', '5910'],
  },
  {
    cst: '90',
    label: '90 - Outras (regime Normal).',
    cfop: ['5103', '5949', '5922', '5114', '5409', '5910'],
  },
  {
    cst: '720',
    label: '720',
    cfop: [
      '5101',
      '5102',
      '5103',
      '5104',
      '5105',
      '5115',
      '5949',
      '5152',
      '5124',
      '5922',
      '5151',
      '5114',
      '5409',
      '5910'
    ],
  },

  // { cst: '101', label: '101 - Tributada pelo Simples Nacional com permissão de crédito.' },
  // { cst: '102', label: '102 - Tributada pelo Simples Nacional sem permissão de crédito.' },
  // { cst: '103', label: '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta.' },

  // { cst: '201', label: '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária.' },
  // { cst: '202', label: '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária.' },
  // { cst: '203', label: '203 - Isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária.' },

  // { cst: '300', label: '300 - Imune.' },
  // { cst: '400', label: '400 - Não tributada pelo Simples Nacional.' },
  // { cst: '500', label: '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação.' },
];

const icms_s_t_devolucao = [
  {
    cst: '00',
    label: '00 - Tributada integralmente',
    cfop: ['5101', '5102', '5103', '5104', '5105', '5115', '5949', '5152'],
  },
  {
    cst: '10',
    label: '10 - Tributada e com cobrança do ICMS por substituição tributária',
    cfop: ['5101', '5102', '5103', '5104', '5105', '5115', '5949', '5152'],
  },
  {
    cst: '20',
    label: '20 - Com redução de base de cálculo',
    cfop: ['5101', '5102', '5103', '5104', '5105', '5115', '5949', '5152'],
  },
  {
    cst: '30',
    label:
      '30 - Isenta ou não tributada e com cobrança do ICMS por substituição tributária',
  },
  {
    cst: '40',
    label: '40 - Isenta',
    cfop: ['5101', '5102', '5103', '5949', '5152'],
  },
  { cst: '41', label: '41 - Não tributada', cfop: ['5103', '5949', '5152'] },
  { cst: '50', label: '50 - Suspensão', cfop: ['5103', '5949'] },
  { cst: '51', label: '51 - Diferimento', cfop: ['5101', '5102', '5949'] },
  {
    cst: '60',
    label: '60 - ICMS cobrado anteriormente por substituição tributária',
    cfop: ['5405'],
  },
  {
    cst: '70',
    label:
      '70 - Com redução de base de cálculo e cobrança do ICMS por substituição tributária',
    cfop: ['5405'],
  },
  { cst: '90', label: '90 - Outras (regime Normal).', cfop: ['5103', '5949'] },

  {
    cst: '101',
    label: '101 - Tributada pelo Simples Nacional com permissão de crédito.',
  },
  {
    cst: '102',
    label: '102 - Tributada pelo Simples Nacional sem permissão de crédito.',
  },
  {
    cst: '103',
    label:
      '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta.',
  },

  {
    cst: '201',
    label:
      '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária.',
  },
  {
    cst: '202',
    label:
      '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária.',
  },
  {
    cst: '203',
    label:
      '203 - Isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária.',
  },

  { cst: '300', label: '300 - Imune.' },
  { cst: '400', label: '400 - Não tributada pelo Simples Nacional.' },
  {
    cst: '500',
    label:
      '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação.',
  },
];

const cfopDescription = [
  {
    cfop: '5101',
    description: 'Venda de produção do estabelecimento;',
  },
  {
    cfop: '5102',
    description: 'Venda de mercadoria de terceiros;',
  },
  {
    cfop: '5103',
    description:
      'Venda de produção do estabelecimento, efetuada fora do estabelecimento;',
  },
  {
    cfop: '5104',
    description:
      'Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento;',
  },
  {
    cfop: '5105',
    description:
      'Venda de prod do estabelecimento que não deva por ele transitar;',
  },
  {
    cfop: '5115',
    description:
      'Venda de mercadoria de terceiros, recebida anteriormente em consignação mercantil;',
  },
  {
    cfop: '5405',
    description:
      'Venda de mercadoria de terceiros, sujeita a ST, como contribuinte substituído;',
  },
  {
    cfop: '5949',
    description:
      'Outra saída de mercadoria ou prestação de serviço não especificado;',
  },
  {
    cfop: '5152',
    description:
      'Transferência de mercadoria adquirida ou recebida de terceiros;',
  },
  {
    cfop: '5401',
    description:
      'Venda de produção do estabelecimento quando o produto esteja sujeito ao regime de substituição tributária;',
  },
  {
    cfop: '5929',
    description:
      'Lançamento efetuado em decorrência de emissão de documento fiscal relativo a operação ou prestação também registrada em equipamento Emissor de Cupom Fiscal - ECF',
  },
  {
    cfop: '6108',
    description:
      'Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte',
  },
  {
    cfop: '1411',
    description:
      'Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária',
  },
  {
    cfop: '5403',
    description:
      'Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto',
  },
  {
    cfop: '5124',
    description: 'Industrialização efetuada para outra empresa',
  },
  {
    cfop: '5151',
    description: ' Venda de Produção do Estabelecimento',
  },
  {
    cfop: '5922',
    description:
      'Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura',
  },
  {
    cfop: '5933',
    description: 'Prestação de serviço tributado pelo ISSQN',
  },
  {
    cfop: '5114',
    description:
      'Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil',
  },
  {
    cfop: '5409',
    description:
      'Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária',
  },
  {
    cfop: '5910',
    description:
      'Remessa em bonificação, doação ou brinde',
  },
];

const cfop_options = [
  {
    value: '5101',
    label: '5101 - Venda de produção do estabelecimento;',
  },
  {
    value: '5102',
    label: '5102 - Venda de mercadoria de terceiros;',
  },
  {
    value: '5103',
    label:
      '5103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento;',
  },
  {
    value: '5104',
    label:
      '5104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento;',
  },
  {
    value: '5115',
    label:
      '5115 - Venda de mercadoria de terceiros, recebida anteriormente em consignação mercantil;',
  },
  {
    value: '5405',
    label:
      '5405 - Venda de mercadoria de terceiros, sujeita a ST, como contribuinte substituído;',
  },
  {
    value: '5949',
    label:
      '5949 - Outra saída de mercadoria ou prestação de serviço não especificado;',
  },
  {
    value: '5401',
    label:
      '5401 - Venda de produção do estabelecimento quando o produto esteja sujeito ao regime de substituição tributária;',
  },
  {
    value: '5929',
    label:
      '5929 - Lançamento efetuado em decorrência de emissão de documento fiscal relativo a operação ou prestação também registrada em equipamento Emissor de Cupom Fiscal - ECF;',
  },
  {
    value: '6108',
    label:
      '6108 - Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte',
  },
  {
    value: '1411',
    label:
      '1411 - Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária',
  },
  {
    value: '5403',
    label:
      '5403 - Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto',
  },
  {
    value: '5124',
    label: '5124 - Industrialização efetuada para outra empresa',
  },
  {
    value: '5151',
    label: '5151 - Venda de Produção do Estabelecimento',
  },
  {
    value: '5922',
    label:
      '5922 - Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura',
  },
  {
    value: '5933',
    label: '5933 - Prestação de serviço tributado pelo ISSQN',
  },
  {
    value: '5151',
    label: '5151 - Transferência de produção do estabelecimento',
  },
  {
    value: '5152',
    label:
      '5152 - Transferência de mercadoria adquirida ou recebida de terceiros',
  },
  {
    value: '5114',
    label:
      '5114 - Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil',
  },
  {
    value: '5409',
    label:
      '5409 - Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária',
  },
  {
    value: '5910',
    label:
      '5910 - Remessa em bonificação, doação ou brinde',
  },
];

const icms_origem = [
  { value: '0', description: '0 - Nacional' },
  { value: '1', description: '1 - Estrangeira (Importação Direta)' },
  { value: '2', description: '2 - Estrangeira (Adquirida no Mercado Interno)' },
  {
    value: '3',
    description: '3 - Nacional com mais de 40% de conteúdo estrangeiro',
  },
  {
    value: '4',
    description:
      '4 - Nacional produzida através de processos produtivos básicos',
  },
  {
    value: '5',
    description: '5 - Nacional com menos de 40% de conteúdo estrangeiro',
  },
  {
    value: '6',
    description:
      '6 - Estrangeira (Importação Direta) sem produto nacional similar',
  },
  {
    value: '7',
    description:
      '7 - Estrangeira (Adquirida no Mercado Interno) sem produto nacional similar',
  },
];

const base_calculo = [
  { value: '0', description: '0 - Margem de Valor Agregado (%)' },
  { value: '1', description: '1 - Pauta (Valor)' },
  { value: '2', description: '2 - Preço Tabelado Máximo (Valor)' },
  { value: '3', description: '3 - Valor da Operação' },
];

const cofins_options = [
  {
    value: '01',
    label:
      '01 – Operação tributável: base de cálculo = valor da operação (alíquota normal – cumulativo/não cumulativo);',
  },
  {
    value: '02',
    label:
      '02 – Operação tributável: base de cálculo = valor da operação (alíquota diferenciada);',
  },
  {
    value: '03',
    label:
      '03 – Operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto;',
  },
  {
    value: '04',
    label: '04 – Operação tributável: tributação monofásica (alíquota zero);',
  },
  {
    value: '05',
    label: '05 – Operação tributável: substituição tributária;',
  },
  { value: '06', label: '06 – Operação tributável: alíquota zero;' },
  { value: '07', label: '07 – Operação isenta da contribuição;' },
  { value: '08', label: '08 – Operação sem incidência da contribuição;' },
  { value: '09', label: '09 – Operação com suspensão da contribuição;' },
  { value: '49', label: '49 – Outras operações de saída;' },
  {
    value: '50',
    label:
      '50 – Operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno;',
  },
  {
    value: '51',
    label:
      '51 – Operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno;',
  },
  {
    value: '52',
    label:
      '52 – Operação com direito a crédito: vinculada exclusivamente a receita de exportação;',
  },
  {
    value: '53',
    label:
      '53 – Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno;',
  },
  {
    value: '54',
    label:
      '54 – Operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação;',
  },
  {
    value: '55',
    label:
      '55 – Operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação;',
  },
  {
    value: '56',
    label:
      '56 – Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação;',
  },
  {
    value: '60',
    label:
      '60 – Crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno;',
  },
  {
    value: '61',
    label:
      '61 – Crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno;',
  },
  {
    value: '62',
    label:
      '62 – Crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação;',
  },
  {
    value: '63',
    label:
      '63 – Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno;',
  },
  {
    value: '64',
    label:
      '64 – Crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação;',
  },
  {
    value: '65',
    label:
      '65 – Crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação;',
  },
  {
    value: '66',
    label:
      '66 – Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação;',
  },
  { value: '67', label: '67 – Crédito presumido: outras operações;' },
  { value: '70', label: '70 – Operação de aquisição sem direito a crédito;' },
  { value: '71', label: '71 – Operação de aquisição com isenção;' },
  { value: '72', label: '72 – Operação de aquisição com suspensão;' },
  { value: '73', label: '73 – Operação de aquisição a alíquota zero;' },
  {
    value: '74',
    label: '74 – Operação de aquisição sem incidência da contribuição;',
  },
  {
    value: '75',
    label: '75 – Operação de aquisição por substituição tributária;',
  },
  { value: '98', label: '98 – Outras operações de entrada;' },
  { value: '99', label: '99 – Outras operações;' },
];

const icms_situacao_tributaria = [
  { value: '00', label: '00 - Tributada integralmente' },
  // { value: '10', label: '10 - Tributada e com cobrança do ICMS por substituição tributária' },
  { value: '20', label: '20 - Com redução de base de cálculo' },
  {
    value: '30',
    label:
      '30 - Isenta ou não tributada e com cobrança do ICMS por substituição tributária',
  },
  { value: '40', label: '40 - Isenta' },
  { value: '41', label: '41 - Não tributada' },
  { value: '50', label: '50 - Suspensão' },
  { value: '51', label: '51 - Diferimento' },
  {
    value: '60',
    label: '60 - ICMS cobrado anteriormente por substituição tributária',
  },
  {
    value: '70',
    label:
      '70 - Com redução de base de cálculo e cobrança do ICMS por substituição tributária',
  },
  { value: '90', label: '90 - Outras (regime Normal).' },

  // { value: '101', label: '101 - Tributada pelo Simples Nacional com permissão de crédito.' },
  // { value: '102', label: '102 - Tributada pelo Simples Nacional sem permissão de crédito.' },
  // { value: '103', label: '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta.' },

  // { value: '201', label: '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária.' },
  // { value: '202', label: '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária.' },
  // { value: '203', label: '203 - Isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária.' },

  // { value: '300', label: '300 - Imune.' },
  // { value: '400', label: '400 - Não tributada pelo Simples Nacional.' },
  // { value: '500', label: '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação.' },
  // { value: '900', label: '900 - Outras (regime Simples Nacional).' },
];

const pis_situacao_tributaria = [
  {
    value: '01',
    label:
      '01 – Operação tributável: base de cálculo = valor da operação (alíquota normal – cumulativo/não cumulativo);',
  },
  {
    value: '02',
    label:
      '02 – Operação tributável: base de cálculo = valor da operação (alíquota diferenciada);',
  },
  {
    value: '03',
    label:
      '03 – Operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto;',
  },
  {
    value: '04',
    label: '04 – Operação tributável: tributação monofásica (alíquota zero);',
  },
  { value: '05', label: '05 – Operação tributável: substituição tributária;' },
  { value: '06', label: '06 – Operação tributável: alíquota zero;' },
  { value: '07', label: '07 – Operação isenta da contribuição;' },
  { value: '08', label: '08 – Operação sem incidência da contribuição;' },
  { value: '09', label: '09 – Operação com suspensão da contribuição;' },

  { value: '49', label: '49 – Outras operações de saída;' },
  {
    value: '50',
    label:
      '50 – Operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno;',
  },
  {
    value: '51',
    label:
      '51 – Operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno;',
  },
  {
    value: '52',
    label:
      '52 – Operação com direito a crédito: vinculada exclusivamente a receita de exportação;',
  },
  {
    value: '53',
    label:
      '53 – Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno;',
  },
  {
    value: '54',
    label:
      '54 – Operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação;',
  },
  {
    value: '55',
    label:
      '55 – Operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação;',
  },
  {
    value: '56',
    label:
      '56 – Operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação;',
  },

  {
    value: '60',
    label:
      '60 – Crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno;',
  },
  {
    value: '61',
    label:
      '61 – Crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno;',
  },
  {
    value: '62',
    label:
      '62 – Crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação;',
  },
  {
    value: '63',
    label:
      '63 – Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno;',
  },
  {
    value: '64',
    label:
      '64 – Crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação;',
  },
  {
    value: '65',
    label:
      '65 – Crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação;',
  },
  {
    value: '66',
    label:
      '66 – Crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação;',
  },
  { value: '67', label: '67 – Crédito presumido: outras operações;' },

  { value: '70', label: '70 – Operação de aquisição sem direito a crédito;' },
  { value: '71', label: '71 – Operação de aquisição com isenção;' },
  { value: '72', label: '72 – Operação de aquisição com suspensão;' },
  { value: '73', label: '73 – Operação de aquisição a alíquota zero;' },
  {
    value: '74',
    label: '74 – Operação de aquisição sem incidência da contribuição;',
  },
  {
    value: '75',
    label: '75 – Operação de aquisição por substituição tributária;',
  },

  { value: '98', label: '98 – Outras operações de entrada;' },
  { value: '99', label: '99 – Outras operações;' },
];

const icms_motivo_desoneracao = [
  { value: '1', label: '1 – Táxi;' },
  { value: '3', label: '3 – Produtor Agropecuário;' },
  { value: '4', label: '4 – Frotista/Locadora;' },
  { value: '5', label: '5 – Diplomático/Consular;' },
  {
    value: '6',
    label:
      '6 – Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio (Resolução 714/88 e 790/94 – CONTRAN e suas alterações);',
  },
  { value: '7', label: '7 – SUFRAMA;' },
  { value: '8', label: '8 – Venda a Órgãos Públicos;' },
  { value: '9', label: '9 – Outros;' },
  { value: '10', label: '10 – Deficiente Condutor (Convênio ICMS 38/12);' },
  { value: '11', label: '11 – Deficiente Não Condutor (Convênio ICMS 38/12);' },
];

const icms_modalidade_base_calculo = [
  { value: '0', label: '0 – Margem Valor Agregado (%)' },
  { value: '1', label: '1 – Pauta (Valor)' },
  { value: '2', label: '2 – Preço Tabela Máx. (Valor)' },
  { value: '3', label: '3 – Valor da operação' },
];

const ICMS_ST = [
  { value: '0', label: '0 – Preço tabelado ou máximo sugerido' },
  { value: '1', label: '1 – Lista negativa (valor)' },
  { value: '2', label: '2 – Lista positiva (valor)' },
  { value: '3', label: '3 – Lista neutra (valor)' },
  { value: '4', label: '4 – Margem de valor agregado (%)' },
  { value: '5', label: '5 – Pauta (valor)' },
  { value: '6', label: '6 – valor da operação (ICMS=70 e ICMS=90)' },
];

//reforma tributaria
const ibs_cbs_situacao_tributaria = [
  {
    value: '000',
    label: '000 - Tributação integral',
    classificacoes: [
      {
        value: '000001',
        label: '000001 - Situações tributadas integralmente pelo IBS e CBS.',
      },
      {
        value: '000002',
        label: '000002 - Exploração de via Regime automotivo',
      },
      {
        value: '000003',
        label: '000003 - Regime automotivo - projetos incentivados (art. 311)',
      },
      {
        value: '000004',
        label: '000004 - Regime automotivo - projetos incentivados (art. 312)',
      },
    ],
  },
  {
    value: '010',
    label: '010 - Tributação com alíquotas uniformes',
    classificacoes: [
      {
        value: '010001',
        label:
          '010001 - Operações do FGTS não realizadas pela Caixa Econômica Federal',
      },
      {
        value: '010002',
        label: '010002 - Operações do serviço financeiro',
      },
    ],
  },
  {
    value: '011',
    label: '011 - Tributação com alíquotas uniformes reduzidas',
    classificacoes: [
      {
        value: '011001',
        label: '011001 - Planos de assistência funerária.',
      },
      {
        value: '011002',
        label: '011002 - Planos de assistência à saúde',
      },
      {
        value: '011003',
        label: '011003 - Intermediação de planos de assistência à saúde',
      },
      {
        value: '011004',
        label: '011004 - Concursos e prognósticos',
      },
      {
        value: '011005',
        label: '011005 - Planos de assistência à saúde de animais domésticos',
      },
    ],
  },
  {
    value: '200',
    label: '200 - Alíquota reduzida',
    classificacoes: [
      {
        value: '200001',
        label:
          '200001 - Aquisições realizadas entre empresas autorizadas a operar em zonas de processamento de exportação',
      },
      {
        value: '200002',
        label:
          '200002 - Fornecimento ou importação para produtor rural não contribuinte ou TAC',
      },
      {
        value: '200003',
        label:
          '200003 - Vendas de produtos destinados à alimentação humana (Anexo I)',
      },
      {
        value: '200004',
        label: '200004 - Venda de dispositivos médicos (Anexo XII)',
      },
      {
        value: '200005',
        label:
          '200005 - Venda de dispositivos médicos adquiridos por órgãos da administração pública (Anexo IV)',
      },
      {
        value: '200006',
        label:
          '200006 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XII)',
      },
      {
        value: '200007',
        label:
          '200007 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo XIII)',
      },
      {
        value: '200008',
        label:
          '200008 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência adquiridos por órgãos da administração pública (Anexo V)',
      },
      {
        value: '200009',
        label: '200009 - Fornecimento de medicamentos (Anexo XIV)',
      },
      {
        value: '200010',
        label:
          '200010 - Fornecimento dos medicamentos registrados na Anvisa, adquiridos por órgãos da administração pública',
      },
      {
        value: '200011',
        label:
          '200011 - Fornecimento das composições para nutrição enteral e parenteral quando adquiridas por órgãos da administração pública (Anexo VI)',
      },
      {
        value: '200012',
        label:
          '200012 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XIV)',
      },
      {
        value: '200013',
        label:
          '200013 - Fornecimento de tampões higiênicos, absorventes higiênicos internos ou externos',
      },
      {
        value: '200014',
        label:
          '200014 - Fornecimento dos produtos hortícolas, frutas e ovos (Anexo XV)',
      },
      {
        value: '200015',
        label:
          '200015 - Venda de automóveis de passageiros de fabricação nacional adquiridos por motoristas profissionais ou pessoas com deficiência',
      },
      {
        value: '200016',
        label:
          '200016 - Prestação de serviços de pesquisa e desenvolvimento por Instituição Científica, Tecnológica e de Inovação (ICT)',
      },
      {
        value: '200017',
        label: '200017 - Operações relacionadas ao FGTS',
      },
      {
        value: '200018',
        label: '200018 - Operações de resseguro e retrocessão',
      },
      {
        value: '200019',
        label: '200019 - Importador dos serviços financeiros contribuinte',
      },
      {
        value: '200020',
        label:
          '200020 - Operação praticada por sociedades cooperativas optantes por regime específico do IBS e CBS',
      },
      {
        value: '200021',
        label:
          '200021 - Serviços de transporte público coletivo de passageiros ferroviário e hidroviário',
      },
      {
        value: '200022',
        label:
          '200022 - Operação originada fora da ZFM que destine bem material industrializado a contribuinte estabelecido na ZFM',
      },
      {
        value: '200023',
        label:
          '200023 - Operação realizada por indústria incentivada que destine bem material intermediário para outra indústria incentivada na ZFM',
      },
      {
        value: '200024',
        label:
          '200024 - Operação originada fora das Áreas de Livre Comércio destinadas a contribuinte estabelecido nas Áreas de Livre Comércio',
      },
      {
        value: '200025',
        label:
          '200025 - Fornecimento dos serviços de educação relacionados ao Programa Universidade para Todos (Prouni)',
      },
      {
        value: '200026',
        label: '200026 - Locação de imóveis localizados nas zonas reabilitadas',
      },
      {
        value: '200027',
        label:
          '200027 - Operações de locação, cessão onerosa e arrendamento de bens imóveis',
      },
      {
        value: '200028',
        label: '200028 - Fornecimento dos serviços de educação (Anexo II)',
      },
      {
        value: '200029',
        label: '200029 - Fornecimento dos serviços de saúde humana (Anexo III)',
      },
      {
        value: '200030',
        label: '200030 - Venda dos dispositivos médicos (Anexo IV)',
      },
      {
        value: '200031',
        label:
          '200031 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo V)',
      },
      {
        value: '200032',
        label:
          '200032 - Fornecimento dos medicamentos registrados na Anvisa ou produzidos por farmácias de manipulação, ressalvados os medicamentos sujeitos à alíquota zero',
      },
      {
        value: '200033',
        label:
          '200033 - Fornecimento das composições para nutrição enteral e parenteral (Anexo VI)',
      },
      {
        value: '200034',
        label:
          '200034 - Fornecimento dos alimentos destinados ao consumo humano (Anexo VII)',
      },
      {
        value: '200035',
        label:
          '200035 - Fornecimento dos produtos de higiene pessoal e limpeza (Anexo VIII)',
      },
      {
        value: '200036',
        label:
          '200036 - Fornecimento de produtos agropecuários, aquícolas, pesqueiros, florestais e extrativistas vegetais in natura',
      },
      {
        value: '200037',
        label:
          '200037 - Fornecimento de serviços ambientais de conservação ou recuperação da vegetação nativa',
      },
      {
        value: '200038',
        label:
          '200038 - Fornecimento dos insumos agropecuários e aquícolas (Anexo IX)',
      },
      {
        value: '200039',
        label:
          '200039 - Fornecimento dos serviços e o licenciamento ou cessão dos direitos destinados às produções nacionais artísticas (Anexo X)',
      },
      {
        value: '200040',
        label:
          '200040 - Fornecimento de serviços de comunicação institucional à administração pública',
      },
      {
        value: '200041',
        label:
          '200041 - Fornecimento de serviço de educação desportiva (art. 141.I)',
      },
      {
        value: '200042',
        label:
          '200042 - Fornecimento de serviço de educação desportiva (art. 141.II)',
      },
      {
        value: '200043',
        label:
          '200043 - Fornecimento à administração pública dos serviços e dos bens relativos à soberania (Anexo XI)',
      },
      {
        value: '200044',
        label:
          '200044 - Operações e prestações de serviços de segurança da informação e segurança cibernética desenv por sociedade que tenha sócio brasileiro (Anexo XI)',
      },
      {
        value: '200045',
        label:
          '200045 - Operações relacionadas a projetos de reabilitação urbana de zonas históricas e de áreas críticas de recuperação e reconversão urbanística',
      },
      {
        value: '200046',
        label: '200046 - Operações com bens imóveis',
      },
      {
        value: '200047',
        label: '200047 - Bares e Restaurantes',
      },
      {
        value: '200048',
        label: '200048 - Hotelaria, Parques de Diversão e Parques Temáticos',
      },
      {
        value: '200049',
        label:
          '200049 - Transporte coletivo de passageiros rodoviário, ferroviário e hidroviário',
      },
      {
        value: '200050',
        label:
          '200050 - Serviços de transporte aéreo regional coletivo de passageiros ou de carga',
      },
      {
        value: '200051',
        label: '200051 - Agências de Turismo',
      },
      {
        value: '200052',
        label: '200052 - Prestação de serviços de profissões intelectuais',
      },
    ],
  },
  {
    value: '220',
    label: '220 - Alíquota fixa',
    classificacoes: [
      {
        value: '220001',
        label:
          '220001 - Incorporação imobiliária submetida ao regime especial de tributação',
      },
      {
        value: '220002',
        label:
          '220002 - Incorporação imobiliária submetida ao regime especial de tributação',
      },
      {
        value: '220003',
        label:
          '220003 - Alienação de imóvel decorrente de parcelamento do solo',
      },
    ],
  },
  {
    value: '221',
    label: '221 - Alíquota fixa proporcional',
    classificacoes: [
      {
        value: '221001',
        label:
          '221001 - Locação, cessão onerosa ou arrendamento de bem imóvel com alíquota sobre a receita bruta',
      },
    ],
  },
  {
    value: '222',
    label: '222 - Redução de Base de Cálculo',
    classificacoes: [
      {
        value: '222001',
        label:
          '222001 - Transporte internacional de passageiros, caso os trechos de ida e volta sejam vendidos em conjunto',
      },
    ],
  },
  {
    value: '400',
    label: '400 - Isenção',
    classificacoes: [
      {
        value: '400001',
        label:
          '400001 - Fornecimento de serviços de transporte público coletivo de passageiros rodoviário e metroviário',
      },
    ],
  },
  {
    value: '410',
    label: '410 - Imunidade e não incidência',
    classificacoes: [
      {
        value: '410001',
        label:
          '410001 - Fornecimento de bonificações quando constem no documento fiscal e que não dependam de evento posterior',
      },
      {
        value: '410002',
        label:
          '410002 - Transferências entre estabelecimentos pertencentes ao mesmo contribuinte',
      },
      {
        value: '410003',
        label: '410003 - Doações sem contraprestação em benefício do doador',
      },
      {
        value: '410004',
        label: '410004 - Exportações de bens e serviços',
      },
      {
        value: '410005',
        label:
          '410005 - Fornecimentos realizados pela União, pelos Estados, pelo Distrito Federal e pelos Municípios',
      },
      {
        value: '410006',
        label:
          '410006 - Fornecimentos realizados por entidades religiosas e templos de qualquer culto',
      },
      {
        value: '410007',
        label: '410007 - Fornecimentos realizados por partidos políticos',
      },
      {
        value: '410008',
        label:
          '410008 - Fornecimentos de livros, jornais, periódicos e do papel destinado a sua impressão',
      },
      {
        value: '410009',
        label:
          '410009 - Fornecimentos de fonogramas e videofonogramas musicais produzidos no Brasil',
      },
      {
        value: '410010',
        label:
          '410010 - Fornecimentos de serviço de comunicação nas modalidades de radiodifusão sonora e de sons e imagens de recepção livre e gratuita',
      },
      {
        value: '410011',
        label:
          '410011 - Fornecimentos de ouro, quando definido em lei como ativo financeiro ou instrumento cambial',
      },
      {
        value: '410012',
        label:
          '410012 - Fornecimento de condomínio edilicio não optante pelo regime regular',
      },
      {
        value: '410013',
        label: '410013 - Exportações de combustíveis',
      },
      {
        value: '410014',
        label: '410014 - Fornecimento de produtor rural não contribuinte',
      },
      {
        value: '410015',
        label:
          '410015 - Fornecimento por transportador autônomo não contribuinte',
      },
      {
        value: '410016',
        label: '410016 - Fornecimento ou aquisição de resíduos sólidos',
      },
      {
        value: '4l0017',
        label:
          '4l0017 - Aquisição de bem móvel com crédito presumido sob condição de revenda realizada',
      },
      {
        value: '410018',
        label:
          '410018 - Operações relacionadas aos fundos garantidores e executores de políticas públicas',
      },
      {
        value: '410019',
        label:
          '410019 - Exclusão da gorjeta na base de cálculo no fornecimento de alimentação',
      },
      {
        value: '410020',
        label:
          '410020 - Exclusão do valor de intermediação na base de cálculo no fornecimento de alimentação',
      },
      {
        value: '410021',
        label:
          '410021 - Contribuição de que trata o art. 149-A da Constituição Federal',
      },
      {
        value: '410022',
        label: '410022 - Consolidação da propriedade do bem pelo credor',
      },
      {
        value: '410023',
        label:
          '410023 - Alienação de bens móveis ou imóveis que tenham sido objeto de garantia em que o prestador da garantia não seja contribuinte',
      },
      {
        value: '410024',
        label:
          '410024 - Consolidação da propriedade do bem pelo grupo de consórcio',
      },
      {
        value: '410025',
        label:
          '410025 - Alienação de bem que tenha sido objeto de garantia em que o prestador da garantia não seja contribuinte',
      },
      {
        value: '410026',
        label: '410026 - Doação com anulação de crédito',
      },
      {
        value: '410999',
        label:
          '410999 - Operações não onerosas sem previsão de tributação, não especificadas anteriormente',
      },
    ],
  },
  {
    value: '510',
    label: '510 - Diferimento',
    classificacoes: [
      {
        value: '510001',
        label:
          '510001 - Operações, sujeitas a diferimento, com energia elétrica, relativas à geração, comercialização, distribuição e transmissão',
      },
    ],
  },
  {
    value: '515',
    label: '515 - Diferimento com redução de alíquota',
    classificacoes: [
      {
        value: '515001',
        label:
          '515001 - Operações, sujeitas a diferimento, com insumos agropecuários e aquícolas destinados a produtor rural não contribuinte (Anexo IX)',
      },
    ],
  },
  {
    value: '550',
    label: '550 - Suspensão',
    classificacoes: [
      {
        value: '550001',
        label: '550001 - Exportações de bens materiais',
      },
      {
        value: '550002',
        label: '550002 - Regime de Trânsito',
      },
      {
        value: '550003',
        label: '550003 - Regimes de Depósito (art. 85)',
      },
      {
        value: '550004',
        label: '550004 - Regimes de Depósito (art. 87)',
      },
      {
        value: '550005',
        label: '550005 - Regimes de Depósito (art. 87, Parágrafo único)',
      },
      {
        value: '550006',
        label: '550006 - Regimes de Permanencia Temporária',
      },
      {
        value: '550007',
        label: '550007 - Regimes de Aperfeiçoamento',
      },
      {
        value: '550008',
        label:
          '550008 - Importação de bens para o Regime de Repetro-Temporário',
      },
      {
        value: '550009',
        label: '550009 - GNL-Temporário',
      },
      {
        value: '550010',
        label: '550010 - Repetro-Permanente',
      },
      {
        value: '550011',
        label: '550011 - Repetro-Industrialização',
      },
      {
        value: '550012',
        label: '550012 - Repetro-Nacional',
      },
      {
        value: '550013',
        label: '550013 - Repetro-Entreposto',
      },
      {
        value: '550014',
        label: '550014 - Zona de Processamento de Exportação',
      },
      {
        value: '550015',
        label:
          '550015 - Regime Tributário para Incentivo à Modernização e à Ampliação da Estrutura Portuária',
      },
      {
        value: '550016',
        label:
          '550016 - Regime Especial de Incentivos para o Desenvolvimento da Infraestrutura',
      },
      {
        value: '550017',
        label:
          '550017 - Regime Tributário para Incentivo à Atividade Econômica Naval',
      },
      {
        value: '550018',
        label: '550018 - Desoneração da aquisição de bens de capital',
      },
      {
        value: '550019',
        label:
          '550019 - Importação de bem material por indústria incentivada para utilização na ZFM',
      },
      {
        value: '550020',
        label: '550020 - Áreas de livre comércio',
      },
      {
        value: '550021',
        label: '550021 - Industrialização destinada a exportações',
      },
    ],
  },
  {
    value: '620',
    label: '620 - Tributação Monofásica',
    classificacoes: [
      {
        value: '620001',
        label: '620001 - Tributação monofásica sobre combustíveis',
      },
      {
        value: '620002',
        label:
          '620002 - Tributação monofásica com responsabilidade pela retenção sobre combustíveis',
      },
      {
        value: '620003',
        label:
          '620003 - Tributação monofásica com tributos retidos por responsabilidade sobre combustíveis',
      },
      {
        value: '620004',
        label:
          '620004 - Tributação monofásica sobre mistura de EAC com gasolina A em percentual superior ao obrigatório',
      },
      {
        value: '620005',
        label:
          '620005 - Tributação monofásica sobre mistura de EAC com gasolina A em percentual inferior ao obrigatório',
      },
      {
        value: '620006',
        label:
          '620006 - Tributação monofásica sobre combustíveis cobrada anteriormente',
      },
    ],
  },
  {
    value: '800',
    label: '800 - Transferência de crédito',
    classificacoes: [
      {
        value: '800001',
        label: '800001 - Fusão, cisão ou incorporação',
      },
      {
        value: '800002',
        label:
          '800002 - Transferência de crédito do associado, inclusive as cooperativas singulares',
      },
    ],
  },
  {
    value: '810',
    label: '810 - Ajuste de IBS na ZFM',
    classificacoes: [
      {
        value: '810001',
        label:
          '810001 - Crédito presumido sobre o valor apurado nos fornecimentos a partir da ZFM',
      },
    ],
  },
  {
    value: '811',
    label: '811 - Ajustes',
    classificacoes: [
      {
        value: '811001',
        label: '811001 - Anulação de Crédito por Saídas Imunes/Isentas',
      },
      {
        value: '811002',
        label: '811002 - Débitos de notas fiscais não processadas na apuração',
      },
      {
        value: '811003',
        label: '811003 - Desenquadramento do Simples Nacional',
      },
    ],
  },
  {
    value: '820',
    label: '820 - Tributação em declaração de regime específico',
    classificacoes: [
      {
        value: '820001',
        label:
          '820001 - Documento com informações de fornecimento de serviços de planos de assinstência à saúde',
      },
      {
        value: '820002',
        label:
          '820002 - Documento com informações de fornecimento de serviços de planos de assinstência funerária',
      },
      {
        value: '820003',
        label:
          '820003 - Documento com informações de fornecimento de serviços de planos de assinstência à saúde de animais domésticos',
      },
      {
        value: '820004',
        label:
          '820004 - Documento com informações de prestação de serviços de consursos de prognósticos',
      },
      {
        value: '820005',
        label:
          '820005 - Documento com informações de alienação de bens imóveis',
      },
      {
        value: '820006',
        label:
          '820006 - Documento com informações de fornecimento de serviços de exploração de via',
      },
    ],
  },
  {
    value: '830',
    label: '830 - Exclusão da Base de Cálculo',
    classificacoes: [
      {
        value: '830001',
        label:
          '830001 - Documento com exclusão da BC da CBS e do IBS de energia elétrica fornecida pela distribuidora à UC',
      },
    ],
  },
];

const ibs_cbs_classificacao_tributaria = ibs_cbs_situacao_tributaria.flatMap(
  (item) =>
    item.classificacoes.map((classificacao) => ({
      value: classificacao.value,
      label: classificacao.label,
    }))
);

export default {
  csosn,
  cfopDescription,
  icms_origem,
  base_calculo,
  cofins_options,
  icms_situacao_tributaria,
  pis_situacao_tributaria,
  icms_motivo_desoneracao,
  icms_modalidade_base_calculo,
  cfop_options,
  cst,
  icms_s_t_devolucao,
  ICMS_ST,
  ibs_cbs_classificacao_tributaria,
  ibs_cbs_situacao_tributaria,
};
